import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaGraduationCap,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const TrainingAndELearningVideoProductionInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Training and E-Learning Video Production in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Empower Your Audience</Subheading>}
        heading={
          <Heading>
            Training & E-Learning{" "}
            <span tw="text-primary-500">Video Production</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in training and e-learning video
            production in **DIFC**, creating engaging, high-quality, and
            interactive videos that enhance learning and development. From
            corporate training to online courses, our videos drive knowledge
            retention and engagement.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1611926653458-09294b3142bf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1599687266075-45d528cb6975?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Training Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Training & E-Learning Video Production in DIFC"
        description="We create videos that inspire learning and growth."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Engaging Visuals",
            description: "High-quality videos that captivate learners.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Proven Expertise",
            description: "Trusted by DIFC organizations for results.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Interactive Content",
            description: "Videos with quizzes and animations for retention.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery for training programs.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform Optimized",
            description: "Compatible with LMS, websites, and mobile devices.",
          },
          {
            icon: <FaGraduationCap color="#ff5464" size={40} />,
            title: "Learning Focused",
            description: "Tailored for corporate and educational needs.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Training & E-Learning Video Production Process"
        description={
          <Description>
            We produce effective training and e-learning videos with a
            streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your training goals and audience.
              </li>
              <li>
                Scripting: Develop clear, engaging scripts for learning
                outcomes.
              </li>
              <li>
                Filming: Capture professional visuals with expert equipment.
              </li>
              <li>
                Editing: Add animations, voiceovers, and interactive elements.
              </li>
              <li>Delivery: Provide ready-to-use videos for your platform.</li>
              <li>Support: Offer revisions and integration guidance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1589884629108-3193400c7cc5?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1560439514-4e9645039924?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Training & E-Learning Video Wins in DIFC"
        description="Our videos have transformed learning in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Improved Engagement",
            description: "Boosted learner participation and retention.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Wider Reach",
            description: "Enhanced training accessibility across platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "98% approval from e-learning video projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Enhance Learning?</Subheading>}
        heading="Training & E-Learning Video Production in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for training and e-learning video
            production in DIFC. Create engaging, interactive videos that empower
            your audience—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
          "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
